import {Injectable} from '@angular/core';
import {SelectedFile} from 'src/app/standalone/image-selector/image-selector.component';
import {FileHttpService} from '../http/file.http';
import {FileInfo, FileInfoData, FileInfoResponse} from '../types/file';
import {UtilsService} from './utils.service';
import {Observable, Subscription} from "rxjs";
import { HttpEvent } from "@angular/common/http";

const BATCH_IN_PARALLEL = 5;
@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private fileService: FileHttpService, private utils: UtilsService) {
  }

  public fileQueue: {
    index: number,
    selectedFile: File,
    fileInfo: FileInfoData,
    percent: number,
    finished: boolean,
    sub: Subscription | null,
    upload_id: string | null,
    attraction_id: string,
    preview?: string,
    archive?: boolean,
    unit_id?: string
  }[] = []
  public progress = 0
  public totalSize = 0
  public loadedSize = 0
  public isUploading = false
  public hideProgress = false

  reset() {
    this.fileQueue = []
    this.progress = 0
    this.totalSize = 0
    this.loadedSize = 0
    this.isUploading = false
  }

  add(selectedFile: File, fileInfo: FileInfoData, attraction_id: string, preview?: string): void {
    this.fileQueue.push({
      index: this.fileQueue.length,
      selectedFile: selectedFile,
      fileInfo: fileInfo as FileInfo,
      percent: 0,
      finished: false,
      sub: null,
      upload_id: null,
      attraction_id: attraction_id,
      preview
    })
  }

  addArchive(selectedFile: File, fileInfo: FileInfoData, attraction_id: string, unit_id: string): void {
    this.fileQueue.push({
      index: this.fileQueue.length,
      selectedFile: selectedFile,
      fileInfo: fileInfo as FileInfo,
      percent: 0,
      finished: false,
      sub: null,
      upload_id: null,
      attraction_id: attraction_id,
      archive: true,
      unit_id: unit_id
    })
  }

  async startQueue(hideProgress = false) {
    if (this.isUploading) return;
    this.isUploading = true;
    this.hideProgress = hideProgress;
    let handle = setInterval(() => {
      let toUpload = this.fileQueue.filter((file) => file.sub === null)
      let currentlyUploadingCount = this.fileQueue.filter((file) => file.sub !== null && !file.finished).length

      if (toUpload.length > 0 && currentlyUploadingCount < BATCH_IN_PARALLEL) {
        for (let i = 0; i < BATCH_IN_PARALLEL - currentlyUploadingCount && i < toUpload.length; i++) {
          let file = toUpload[i];
          this.createUploadPromise(file.index);
        }
      }
    }, 500);

    while (this.fileQueue.length !== 0 && this.fileQueue.some((file) => !file.finished)) {
      await new Promise(resolve => setTimeout(resolve, 500));
    }
    clearInterval(handle);
    this.isUploading = false;
    this.hideProgress = false;
  }

  createUploadPromise(index: number): Promise<FileInfoResponse> {
    return new Promise<FileInfoResponse>((resolve, reject) => {
      let obs: Observable<HttpEvent<FileInfoResponse>>;
      if (this.fileQueue[index].archive) {
        obs = this.fileService.uploadArchive(this.fileQueue[index].attraction_id, this.fileQueue[index].unit_id || "", this.fileQueue[index].selectedFile, this.fileQueue[index].fileInfo)
      } else {
        obs = this.fileService.createFile(this.fileQueue[index].attraction_id, this.fileQueue[index].selectedFile, this.fileQueue[index].fileInfo)
      }
      this.fileQueue[index].sub = obs.subscribe((res) => {
        if (this.utils.isHttpResponse(res) && res.body) {
          this.fileQueue[index].fileInfo = res.body.file;
          this.fileQueue[index].upload_id = res.body.file.id;
          this.fileQueue[index].finished = true;
          resolve(res.body)
        }

        if (this.utils.isHttpProgressEvent(res) && res.total) {
          this.fileQueue[index].percent = Math.round(100 * res.loaded / this.fileQueue[index].selectedFile.size);
          this.calculateProgress();
        }

      }, (err) => {
        reject(err)
      }, () => {
        if (!this.fileQueue[index].finished) {
          reject("Canceled by user")
        }
      });
    });
  }

  calculateProgress() {
    this.progress = 0
    this.totalSize = 0
    this.loadedSize = 0
    this.fileQueue.forEach((file) => {
      this.totalSize += file.selectedFile.size
      this.loadedSize += file.selectedFile.size * file.percent / 100
    })
    this.progress = Math.round(100 * this.loadedSize / this.totalSize)
  }

  onCancel(index: number) {
    this.fileQueue[index].sub?.unsubscribe();
  }

  cancelQueue() {
    for (let i = 0; i < this.fileQueue.length; i++) {
      this.onCancel(i)
    }
    this.reset();
  }
}
